export default __webpack_public_path__ + "static/media/198onefloorplan.3038a185.svg";